import { COUNTRY_CODES } from '@savgroup-front-common/constants';
import { PartnerScenarioTypes } from '@savgroup-front-common/types';

import type { FileSummaryNewUi } from '../components/DossierFileSummary/FileSummaryNewUi.types';
import type { DossierRow } from '../types/dossier.types';

export const MOCK_DOSSIERS: DossierRow[] = [
  {
    fileId: 'a1000001-0000-4000-8000-000000000001',
    claimId: 'c1000001-0000-4000-8000-000000000001',
    numeroDossier: 'DOS-2024-001',
    numeroTracking: '1Z999AA10123456784',
    numeroCommande: 'CMD-2024-001',
    clientPrenom: 'Marie',
    clientNom: 'Dupont',
    clientEmail: 'marie.dupont@example.com',
    clientPhone: '+33601020304',
    dateCreation: '2024-01-15',
    dateDerniereModif: '2024-02-20',
    statut: 'Dossier cloturé',
    motif: 'Produit en panne',
    garantie: 'Sous garantie constructeur',
    intervenant: 'Martin Dupont',
    orderId: 'o1000001-0000-4000-8000-000000000001',
    sellerName: 'Boutique Demo',
    purchaseStoreName: 'Magasin Paris Centre',
  },
  {
    fileId: 'a1000002-0000-4000-8000-000000000002',
    claimId: 'c1000002-0000-4000-8000-000000000002',
    numeroDossier: 'DOS-2024-002',
    numeroTracking: '6A987654321FR',
    numeroCommande: 'CMD-2024-002',
    clientPrenom: 'Thomas',
    clientNom: 'Bernard',
    clientEmail: 'thomas.bernard@example.com',
    clientPhone: '+33605060708',
    dateCreation: '2024-01-18',
    dateDerniereModif: '2024-02-22',
    statut: "Deuxième relance envoyée à l'acteur du dossier",
    motif: 'Produit en panne',
    garantie: 'Garantie rétractation',
    intervenant: 'Sophie Bernard',
    orderId: 'o1000002-0000-4000-8000-000000000002',
    sellerName: 'Boutique Demo',
    purchaseStoreName: 'Magasin Lyon Part-Dieu',
  },
  {
    fileId: 'a1000003-0000-4000-8000-000000000003',
    claimId: 'c1000003-0000-4000-8000-000000000003',
    numeroDossier: 'DOS-2024-003',
    numeroTracking: '3S123456789012345',
    numeroCommande: 'CMD-2024-003',
    clientPrenom: 'Sophie',
    clientNom: 'Martin',
    clientEmail: 'sophie.martin@example.com',
    clientPhone: '+33609101112',
    dateCreation: '2024-02-01',
    dateDerniereModif: '2024-02-25',
    statut: 'Colis pris en charge par le transporteur',
    motif: 'Produit en panne',
    garantie: 'hors garantie',
    intervenant: 'Pierre Martin',
    orderId: 'o1000003-0000-4000-8000-000000000003',
    sellerName: 'Boutique Demo',
    purchaseStoreName: 'Magasin Marseille',
  },
  {
    fileId: 'a1000004-0000-4000-8000-000000000004',
    claimId: 'c1000004-0000-4000-8000-000000000004',
    numeroDossier: 'DOS-2024-004',
    numeroTracking: '8Q555666777FR',
    numeroCommande: 'CMD-2024-004',
    clientPrenom: 'Julie',
    clientNom: 'Leroy',
    clientEmail: 'julie.leroy@example.com',
    clientPhone: '+33613141516',
    dateCreation: '2024-02-05',
    dateDerniereModif: '2024-02-26',
    statut: "En attente d'expédition [RMA automatique]",
    motif: 'Produit en panne',
    garantie: 'Sous garantie constructeur',
    intervenant: 'Julie Leroy',
    orderId: 'o1000004-0000-4000-8000-000000000004',
    sellerName: 'Boutique Demo',
    purchaseStoreName: 'Magasin Lille',
  },
  {
    fileId: 'a1000005-0000-4000-8000-000000000005',
    claimId: 'c1000005-0000-4000-8000-000000000005',
    numeroDossier: 'DOS-2024-005',
    numeroTracking: '2B111222333FR',
    numeroCommande: 'CMD-2024-005',
    clientPrenom: 'Pierre',
    clientNom: 'Petit',
    clientEmail: 'pierre.petit@example.com',
    clientPhone: '+33617181920',
    dateCreation: '2024-02-10',
    dateDerniereModif: '2024-02-27',
    statut: 'Demande RMA en attente de confirmation par le fournisseur [RMA manuelle]',
    motif: 'Produit en panne',
    garantie: 'Garantie rétractation',
    intervenant: 'Thomas Petit',
    orderId: 'o1000005-0000-4000-8000-000000000005',
    sellerName: 'Boutique Demo',
    purchaseStoreName: 'Magasin Bordeaux',
  },
];

export const getDossierByFileId = (fileId: string | undefined): DossierRow | undefined =>
  MOCK_DOSSIERS.find((dossier) => dossier.fileId === fileId);

export const buildDossierFileSummary = (dossier: DossierRow): FileSummaryNewUi => ({
  owner: {
    id: `owner-${dossier.fileId}`,
    firstname: dossier.clientPrenom,
    lastname: dossier.clientNom,
    email: dossier.clientEmail,
    phone: dossier.clientPhone,
    address: {
      countryCode: COUNTRY_CODES.FR,
    },
    isAnonymous: false,
  },
  context: {
    orderReference: dossier.numeroCommande,
    sellerName: dossier.sellerName,
    purchaseDate: new Date(dossier.dateCreation),
    assignedUserName: dossier.intervenant,
    storeActorName: dossier.purchaseStoreName,
    siteActorName: 'Centre SAV national',
    depositStoreName: dossier.purchaseStoreName,
    purchaseStoreName: dossier.purchaseStoreName,
    marketPlace: '',
    products: [
      {
        holder: {
          holderId: 'holder-1',
          holderName: dossier.purchaseStoreName,
          holderType: 'STORE',
        },
        issueId: 'issue-1',
        reasonId: 'reason-1',
        solutionTypeId: 'solution-1',
        translations: {
          issueName: dossier.motif,
          reasonName: dossier.motif,
          solutionName: 'Réparation sous garantie',
          warrantyTypeName: dossier.garantie,
        },
        modelDisplayName: 'Modèle démo',
        brandDisplayName: 'Marque démo',
        ownerProductId: `product-${dossier.fileId}`,
        reasonComment: dossier.motif,
        sku: `SKU-${dossier.numeroDossier.slice(-3)}`,
        ean: '3760123456789',
        description: 'Produit démo — description courte',
      },
    ],
    sellerId: 'seller-demo',
    siteActor: {
      actorType: 'REPAIRER_HUB',
      id: `site-${dossier.fileId}`,
    },
    orderId: dossier.orderId,
    partnerScenarioType: PartnerScenarioTypes.NONE,
    order: {},
    ownerProduct: {},
  },
  createdDate: new Date(dossier.dateCreation),
  fullSummary: {
    siteActorId: `site-${dossier.fileId}`,
    siteActorType: 'REPAIRER_HUB',
    actorId: `actor-${dossier.fileId}`,
    actorType: 'REPAIRER_PARTNER',
    storeActorId: `store-${dossier.fileId}`,
    currentState: {
      name: dossier.statut,
    },
    assignment: {
      currentUser: {
        assignedUserName: dossier.intervenant,
      },
    },
    commercialSolution: {},
    commercialGesture: {},
    refund: {},
  },
});

export const getDossierFileSummaryByFileId = (
  fileId: string | undefined,
): FileSummaryNewUi | undefined => {
  const dossier = getDossierByFileId(fileId);

  if (!dossier) {
    return undefined;
  }

  return buildDossierFileSummary(dossier);
};